module.exports = __webpack_public_path__ + "static/img/fullscreen-image_customize-your-theme-and-questions_600.403d6be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surveys/fullscreen-image_customize-your-theme-and-questions_600.png
// module id = P7xE
// module chunks = 0